import { render } from "./ReviewTemplateDetails.vue?vue&type=template&id=5f21ff0a&scoped=true"
import script from "./ReviewTemplateDetails.vue?vue&type=script&lang=js"
export * from "./ReviewTemplateDetails.vue?vue&type=script&lang=js"

import "./ReviewTemplateDetails.vue?vue&type=style&index=0&id=5f21ff0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f21ff0a"]])

export default __exports__